const TopicTwo = () => {
  return (
    <div className="quality-section-market">
      <div className="quality-header-market">
        <h1>Trading Conditions That Empower Every Move</h1>
        <p>
          Experience transparent pricing, lightning-fast execution, and flexible
          leverage designed for precision and performance in every trade.
        </p>
      </div>
    </div>
  );
};

export default TopicTwo;
